import React, { Component } from 'react';
import { navigate } from '@reach/router'
import ProjectConfig from '../presentation/project-config';
import { getConfigParamsTemplateName } from '../../services/helpers'
export default class ProjectConfigWidget extends Component {
    state = {
        projectId: null,
        projectData: null,
        showModal: false,
        configParams: [],
        useCaseType: ''
    }

    componentWillMount = () => {
        this.loadData()
    }

    loadData = async () => {
        try {
            const configParamsResponse = await this.getConfigurationParams()
            const projectDataResponse = await this.loadProjectFromServer(this.props.projectId)

            const configParams = await configParamsResponse.json()
            const projectData = await projectDataResponse.json()
            const useCaseType = getConfigParamsTemplateName(projectData, configParams)
           
            this.setState({ configParams, projectData, useCaseType })

        } catch (error) {
            console.error('Error =>', error);
        }
    }

    loadProjectFromServer(projectId) {
        this.setState({ projectId });
        return window.fetch("/service/project/" + projectId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin'
        })
    }

    getConfigurationParams() {
      return fetch("/service/configurationParams/", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("idToken")}`,
        },
        credentials: "same-origin",
      })
    }

   updateConfigParams = () => {
    const { projectId, useCaseType } = this.state;
    fetch("/service/updateConfigParams/", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("idToken")}`,
        },
        credentials: "same-origin",
        body: JSON.stringify({ projectId, useCaseType }),
      })
      .then((response) => {
        if (response.status != 204) {
          response.json().then((json) => console.log("Error =>", json));
        } else {
          this.closeModal();
          navigate(`/customer/${this.props.id}/projects`);
        }
      });
  }

  updateUseCaseType = (event) => {
    const useCaseType = event.target.value;
    this.setState({ useCaseType });
  }

  closeModal = () => {
    this.setState({showModal: false});
  }

  openModal = () => {
    this.setState({showModal: true});
  }

  render = () => (
    <ProjectConfig
      project={this.state.projectData}
      configurationParams={this.state.configParams}
      showModal={this.state.showModal}
      useCaseType={this.state.useCaseType}
      updateUseCaseType={this.updateUseCaseType}
      updateConfigParams={this.updateConfigParams}
      openModal={this.openModal}
      closeModal={this.closeModal}
    />
  );
} // ProjectConfigWidget
